module.exports = __webpack_public_path__ + "img/ball_8_transparent.0aefa61b.png";